import { RichCell, Text } from '@vkontakte/vkui';
/**
 * Импортируется из dist, по нескольким причинам:
 * 1. Компонент TextTooltip нам не подходит,
 * 2. Компонент RichTooltip возможно получить пока тоже из dist, но у него цвет стрелочки черный
 */
import { type HoverPopperProps, HoverPopper } from '@vkontakte/vkui/dist/components/HoverPopper/HoverPopper';
import classNames from 'clsx';
import React, { type ReactNode, FC, useEffect } from 'react';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';

import styles from './QuotaCleanerTooltip.css';

type QuotaCleanerTooltipProps = Resolve<
    Omit<HoverPopperProps, 'arrow' | 'arrowClassName' | 'className' | 'content'> & {
        /**
         * Флаг скрытия/показа иконки закрытия
         */
        hasClose?: boolean;
        /**
         * Содержимое тултипа
         */
        text: string;
        /**
         * Кнопки
         * Пока нереализованы
         */
        actions?: ReactNode;
        /**
         * Колбек для закрытия тултипа на иконку закрытия
         */
        onClose?: () => void;
        /**
         * Коллбек на клик вне тултипа
         */
        onClickOutside?: () => void;
    }
>;

/**
 * Экспериментальный тултип для чистилки Единой квоты
 */
export const QuotaCleanerTooltip: FC<QuotaCleanerTooltipProps> = ({
    children,
    text,
    hasClose,
    onClose,
    onClickOutside,
    actions,
    ...restProps
}) => {
    useEffect(() => {
        if (onClickOutside) {
            window.addEventListener('click', onClickOutside);
            return () => window.removeEventListener('click', onClickOutside);
        }
    }, []);

    return (
        <HoverPopper
            className={classNames(styles.root, { [styles.closeButton]: hasClose })}
            arrow
            arrowClassName={styles.arrow}
            onClick={(event) => {
                event.stopPropagation();
            }}
            content={
                <RichCell
                    className={styles.cellContent}
                    multiline
                    disabled
                    actions={actions}
                    after={hasClose ? <CancelIcon onClick={onClose} className={styles.closeIcon} /> : null}
                >
                    <Text className={styles.textContent}>{text}</Text>
                </RichCell>
            }
            {...restProps}
        >
            {children}
        </HoverPopper>
    );
};
